module.exports = __webpack_public_path__ + "build/img/banner2.d25f4fd2.jpg";